<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Select from "primevue/select";
import Calendar from "primevue/calendar";
import FormLabel from "@/components/FormLabel.vue";
import { SUBSCRIPTION_PLANS } 
  from "@/dashboard/organization/Organization";

export default {
  name: "SubscriptionExtensionDialog",
  components: { FormLabel, Button, Dialog, Select, Calendar },
  emits: ["close", "submit"],

  props: {
    visible: {
      type: Boolean,
      required: true,
      default() { return false; }
    },
    member: {
      type: [Object, null],
      required: true,
      default() { return null; }
    },
    categories: {
      type: Array,
      required: true,
      default() { return []; }
    }
  },

  computed: {
  shown() {
    return this.visible;
  },

  orgMember() {
    return this.member;
  },

  subscriptionOptions() {
    return [...SUBSCRIPTION_PLANS];
  },

  filteredCategories() {
    if (!this.member?.categoriesIds?.length) return [];

    return this.categories.filter(cat =>
      this.member.categoriesIds.includes(cat.value)
    );
  }
},

  data() {
    return {
      selectedCategory: null,
      extendedTo: null,
      selectedSubscription: null,
       existingSubscription: null
    };
  },

watch: {
  member: {
    immediate: true,
    handler(val) {
      if (val?.subscription) {
        this.selectedSubscription = val.subscription;
      }

      // reset when member changes
      this.selectedCategory = null;
      this.existingSubscription = null;
    }
  },

selectedCategory(newVal) {
  if (!newVal || !this.member?.subscriptionsMap) {
    this.existingSubscription = null;
    this.selectedSubscription = null;
    return;
  }

  const selectedCat = this.filteredCategories.find(
    cat => cat.value === newVal
  );

  if (!selectedCat) {
    this.existingSubscription = null;
    this.selectedSubscription = null;
    return;
  }

  const match = Object.entries(this.member.subscriptionsMap)
    .find(([key]) =>
      key.toLowerCase().trim() === selectedCat.label.toLowerCase().trim()
    );

  if (match) {
    this.existingSubscription = match[1];

    // 🔥 THIS LINE FIXES DROPDOWN SELECTION
    this.selectedSubscription =
      match[1].subscription?.toUpperCase() || null;
  } else {
    this.existingSubscription = null;
    this.selectedSubscription = null;
  }
}},

  methods: {
 submitExtension() {

  if (!this.selectedCategory || !this.selectedSubscription) {
    this.$root.showAlert(
      "warn",
      "Subscription Extension",
      "Category and Subscription are required"
    );
    return;
  }

  const payload = this.$root.addInstitutionId({
    memberId: this.orgMember.id,
    categoryId: this.selectedCategory,
    subscription: this.selectedSubscription
  }, false, true);

  const TITLE = "Subscription Extension";

  this.$api.post("/institution/subscription/extend", payload)
    .then(res => {
      this.$root.showAlert("success", TITLE, res.message);
      this.$emit("close", res.object);
    })
   .catch(err => {
  const msg =
    err?.response?.data?.message || "Oops, Something Went Wrong";

  this.$root.showAlert("error", TITLE, msg);
});

} ,
formatDate(date) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString();
}

  }
};
</script>

<template>
  <Dialog
    :visible="shown"
    class="w-md-50 w-100"
    :draggable="false"
    :modal="true"
    :close-on-escape="false"
    :header="(orgMember.firstName + ' ' + orgMember.lastName).toUpperCase()"
    :closable="false"
  >
    <div class="row mt-4">

      <!-- Category -->
      <div class="col-12 mb-3">
        <FormLabel label-text="Category" required />
       <Select
  :options="filteredCategories"
          v-model="selectedCategory"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Category"
          class="w-100"
        />
      </div>


<!-- Existing Subscription Text -->
<div v-if="existingSubscription" class="col-12 mb-2">
  <small class="text-muted fw-bold">
    Existing Subscription :
  </small>

  <div class="fw-bold text-primary">
    {{ existingSubscription.subscription }}
  </div>

  <div class="text-muted small">
    <div>
      Start Date :
      {{ formatDate(existingSubscription.start) }}
    </div>
    <div>
      End Date :
      {{ formatDate(existingSubscription.deadline) }}
    </div>
  </div>
</div>
      <div class="col-12 mb-3">
  <FormLabel label-text="Subscription" required />
  <Select
    :options="subscriptionOptions"
    v-model="selectedSubscription"
    optionLabel="label"
    optionValue="value"
    placeholder="Select Subscription"
    class="w-100"
  />
</div>


     

    </div>

    <template #footer>
      <div class="row w-100 px-0 mx-0">
        <div class="col-6 ps-0">
          <Button
            label="Cancel"
            severity="danger"
            @click="$emit('close')"
            class="w-100"
            icon="pi pi-times"
          />
        </div>
        <div class="col-6 pe-0">
          <Button
            label="Submit"
            severity="success"
            @click="submitExtension"
            class="w-100"
            icon="pi pi-check"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<style scoped>
</style>